import PortfolioWrapper from './PortfolioWrapper';

export default PortfolioWrapper;
